module.exports = __webpack_public_path__ + "static/media/message.776da8aa.less";